// extracted by mini-css-extract-plugin
export var btn = "styles-module--btn--9c33a";
export var firstGlow = "styles-module--first-glow--824de";
export var image = "styles-module--image--25097";
export var mainContent = "styles-module--main-content--47c1e";
export var note = "styles-module--note--8bd00";
export var subtitle = "styles-module--subtitle--8bade";
export var suptitle = "styles-module--suptitle--790f2";
export var title = "styles-module--title--9a122";
export var wrapper = "styles-module--wrapper--8ab05";